module.exports = __webpack_public_path__ + "fonts/f0af843.ttf";